// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData_ContactData__20AK_","Headers":"ContactData_Headers__3dK6E"};